import { IFluidCodeDetails } from '@fluidframework/core-interfaces';
import { getPackageName } from './getPackageName';
/**
 * When a host is calling attach for an odsp storage attach, use this helper to create the full file path (with extension)
 */
export function getFullODSPFileName(codeDetails: IFluidCodeDetails, fileName: string): string {
  const packageName = getPackageName(codeDetails);

  switch (packageName) {
    case '@ms/onenote-meetings':
      return `${fileName}.note`;
    case '@ms/whiteboard-container':
      return `${fileName}.whiteboard`;
    default:
      return `${fileName}.fluid`;
  }
}
